import Axios from "axios";
import { navigate } from "wouter/use-browser-location";
import { normalizeReturnTo } from "@/features/auth/utils/auth-state";

/*
 * A shared global instance of the API client.
 */
export const api = Axios.create({
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

/*
 * An Axios interceptor to trap any 401 errors before redirecting back to
 * the auth page, and any 402 errors (inactive subscription) to the
 * subscription-expired page instead of logging the user out.
 */
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const returnTo = normalizeReturnTo(window.location.pathname + window.location.search);
      const params = new URLSearchParams();

      if (returnTo) {
        params.set("returnTo", returnTo);
      }

      navigate(`/auth/signin?${params.toString()}`, { replace: true });
    }

    if (error.response?.status === 402) {
      navigate("/auth/subscription-expired", { replace: true });
    }

    return Promise.reject(error);
  },
);

